"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.render = exports.main = exports["default"] = exports.App = void 0;
var _react = _interopRequireDefault(require("react"));
var _client = require("react-dom/client");
var _reactRedux = require("react-redux");
require("./setup");
require("./versionInfo");
var _initServices = require("./initServices");
var _Routing = _interopRequireDefault(require("./Routing"));
var _Store = require("./Store");
var _ServiceLocator = require("./ServiceLocator");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var App = exports.App = function App() {
  return /*#__PURE__*/_react["default"].createElement(_reactRedux.Provider, {
    store: _Store.store
  }, /*#__PURE__*/_react["default"].createElement(_Routing["default"], null));
};
var render = exports.render = function render() {
  (0, _client.createRoot)(document.getElementById('root')).render( /*#__PURE__*/_react["default"].createElement(App, null));
};
var main = exports.main = function main() {
  var services = (0, _initServices.initServices)();
  _ServiceLocator.Services.store.setStore(_Store.store);
  services.configurator.initialize();
};
var _default = exports["default"] = App;